import { cn } from '@/utils/cn';
import { ReactNode } from 'react';

interface LivescoreEntityLink {
  children?: ReactNode;
  href: string;
  isAhref?: boolean;
  className?: string;
}

const LivescoreEntityLink = ({ children, href, isAhref, className }: LivescoreEntityLink) => {
  const handleClick = (url: string) => {
    window.location.href = url;
  };

  return isAhref ? (
    <a href={href} className={className}>
      {children}
    </a>
  ) : (
    <div className={cn('cursor-pointer', className)} onClick={() => handleClick(href)}>
      {children}
    </div>
  );
};

export default LivescoreEntityLink;
